import { useState, useRef, useContext, useEffect, createContext } from "react"
import { getBasketCount, getBasketFlow, getBasket as basketService } from "../api"
import { makeOrder } from "../utils"
import { redirect } from "../utils/redirect.service"
import { useLoading } from "./loading"
import { useSession } from "./session"
import config from "../environments/generated.config"
import { sendMessage } from "../utils/message.service"

const { home, dashboard } = config.urls
const Context = createContext()

export const Formatter = (data) => {
  const types = Object.keys(data).filter((type) => data[type] && data[type]?.order?.length)

  return types.map((type) => makeOrder(type, data[type]))
}

export const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState([])
  let mounted = useRef(true)
  const { setLoading } = useLoading()
  const { hasSession } = useSession()

  const getHasBasketContent = async () => {
    const data = await getBasketCount()
    const basketCount = data?.total || 0
    if (basketCount === 0) {
      sendMessage({
        action: "refreshBasket",
      })
      redirect(`${home}${dashboard}`)
    }
  }

  const getBasket = async () => {
    try {
      setLoading(true)
      getHasBasketContent()
      const data = await basketService()
      setBasket(Formatter(data))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!hasSession || !mounted) {
      return null
    }
    console.log("initializing basket provider")
    getBasket()
    return () => {
      mounted = false
    }
  }, [hasSession])

  return <Context.Provider value={{ basket, basketReload: getBasket }}>{children}</Context.Provider>
}

export const useBasket = () => useContext(Context)

export const getHasBasketContent = async () => {
  sendMessage({
    action: "refreshBasket",
  })
}
